var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroSmall'),_c('b-container',{staticClass:"mt-5 mb-5"},[_c('h1',{staticClass:"display-1"},[_vm._v(_vm._s(this.$route.params.continent))])]),_c('Blogs',{attrs:{"tag":this.$route.params.continent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }